import { render, staticRenderFns } from "./myCollectKnow.vue?vue&type=template&id=4d433748&scoped=true&"
import script from "./myCollectKnow.vue?vue&type=script&lang=ts&"
export * from "./myCollectKnow.vue?vue&type=script&lang=ts&"
import style0 from "./myCollectKnow.vue?vue&type=style&index=0&id=4d433748&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d433748",
  null
  
)

export default component.exports